import { Card, CardContent, CardHeader, CardTitle } from "@bcc/components/ui/card";
import { ChartContainer, ChartTooltip, ChartTooltipContent } from "@bcc/components/ui/chart";
import { useTranslation } from "react-i18next";
import { Bar, BarChart, CartesianGrid, XAxis, YAxis } from "recharts";
import { setTopProductsChartContainerTestId, setTopProductsChartTitleTestId } from "./top-products-chart.utils";

interface TopProductData {
  product: string;
  sales: number;
}

interface TopProductsChartProps {
  data: TopProductData[];
  testId?: string;
}

export function TopProductsChart({ data, testId }: TopProductsChartProps) {
  const { t } = useTranslation();
  return (
    <Card testId={testId ?? setTopProductsChartContainerTestId()}>
      <CardHeader>
        <CardTitle data-testid={setTopProductsChartTitleTestId()}>{t("components.topProductsChart.title")}</CardTitle>
      </CardHeader>
      <CardContent>
        <ChartContainer
          config={{
            sales: {
              label: t("components.topProductsChart.salesLabel"),
              color: "hsl(var(--primary))",
            },
          }}
          className="h-[400px]"
        >
          <BarChart data={data} layout="vertical">
            <CartesianGrid strokeDasharray="3 3" className="stroke-muted" />
            <XAxis type="number" className="text-xs" tickLine={false} axisLine={false} />
            <YAxis type="category" dataKey="product" className="text-xs" tickLine={false} axisLine={false} width={150} />
            <ChartTooltip content={<ChartTooltipContent />} />
            <Bar dataKey="sales" fill="hsl(var(--primary))" radius={[0, 8, 8, 0]} />
          </BarChart>
        </ChartContainer>
      </CardContent>
    </Card>
  );
}
